// import external dependencies
import 'jquery';

// Import everything from autoload


import { CountUp } from 'countup.js';


import Splide from '@splidejs/splide';

new Splide( '#splide-testimonials-about', {
	perPage: 1,
  arrows: false,
  autoHeight: false,
  pagination: true,
  classes: {
		// Add classes for arrows.
		// arrows: 'splide__arrows your-class-arrows',
		// arrow : 'splide__arrow your-class-arrow',
		// prev  : 'splide__arrow--prev your-class-prev',
		// next  : 'splide__arrow--next your-class-next',
		
		// Add classes for pagination.
		pagination: 'splide__pagination', // container
		page      : 'splide__pagination__page w-4 h-4 block border rounded-full', // each button
	},



} ).mount();


// const pagination = splideTest.Components.Pagination.data.list;

// //console.log(pagination);

// document.getElementById('place-pagination').appendChild(pagination);  

// splideTest.on( 'pagination:updated', function() {

//   let move = splideTest.Components.Pagination.data.list;
//   document.getElementById('place-pagination').appendChild(move);  

//   console.log(move);

//   console.log('Ive Moved');


document.addEventListener('aos:in:count-start', () => {

const target = document.querySelectorAll('.count-up');

//console.log('This is all: ' + target);

target.forEach(e => { 

  const endVal = e.getAttribute('countVal')

  //console.log('This is the end: ' + endVal );

    // const countAmount = '1000';
    const countUp = new CountUp(e, endVal, {duration: 4, separator: '', suffix: ''} );

    countUp.start();

});

});